import { Elements } from 'prismic-reactjs'
import linkResolver from './linkResolver'
import ResolvingLink from '../components/ResolvingLink'
import React from 'react'

const genericHtmlSerializer = (type, element, content, children, key) => {
  switch (type) {
    // Add a class to paragraph elements
    case Elements.paragraph:
      if (
        !children ||
        children.length == null ||
        children.length === 0 ||
        children[0] == null
      ) {
        return React.createElement('br', { key })
      }

      return React.createElement('p', { key }, children)
    case Elements.hyperlink:
      const linkProp = {
        link_type: element.data.link_type,
        target: element.data.target,
        url: element.data.url || linkResolver(element.data),
      }

      return (
        <ResolvingLink key={key} className="underline" link={linkProp}>
          {children}
        </ResolvingLink>
      )

    default:
      return null
  }
}

export default genericHtmlSerializer
